export default __webpack_public_path__ + "static/media/Approved_Gray.f9fbf925.svg";